import { cn } from "@omni/utils/styles";

import { InfoCardsComponent } from "@/components/Product/ProductPage/components/infoCards/infoCards.component";

type Props = {
    className?: string;
};

export const InfoCards = ({ className }: Props) => {
    return <InfoCardsComponent className={cn(className)} />;
};
